<script>
    import { getContext } from "svelte";
    import { slide } from "svelte/transition";
    import { quintOut } from "svelte/easing";


    import { createForm } from "svelte-forms-lib";
    import Svelecte from 'svelecte';
	import Select from "./Fields/Select.svelte";
	import Number from "./Fields/Number.svelte";
	import Text from "./Fields/Text.svelte";

    import * as yup from "yup";
    import axios from "axios";

    import { token } from "../../store"
    
    import { useQuery, useMutation  } from '@sveltestack/svelte-query'
    const profilData = useQuery("profilData")

    import {
        FormGroup,
        Label,
        Spinner
    } from 'sveltestrap';
    import Swal from 'sweetalert2';
    import twemoji from "twemoji";

    import { _ } from "svelte-i18n";

    let apiUrl = getContext("apiUrl");
    let postURL = apiUrl + 'ProfilUpdateAbout.php?token=' + $token;

    let result;

    let mutation = useMutation(val => axios.post(postURL, val), {
        onSuccess: (data) => {
            result = data.data

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                iconColor: 'white',
                customClass: {
                popup: 'colored-toast'
                },
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true
            })

            if(result.success){
                window.navigator.vibrate(200);
                Toast.fire({
                    icon: 'success',
                    title: result.success
                })
            }

            if(result.error){
                Toast.fire({
                    icon: 'error',
                    title: result.error
                })
            }
        }
    });
    
    const { form, errors, handleChange, isSubmitting, handleSubmit, isValid } = createForm({
        initialValues: {
            interestedGender          : $profilData.data.interestedGender,
            search                    : $profilData.data.profilAbout.search,
            children                  : $profilData.data.profilAbout.children,
            children_number           : $profilData.data.profilAbout.children_number,
            first_step                : $profilData.data.profilAbout.first_step,
            live_with                 : $profilData.data.profilAbout.live_with,
            favorite_animal           : $profilData.data.profilAbout.favorite_animal,
            work                      : $profilData.data.profilAbout.work,
            favorite_social_network   : $profilData.data.profilAbout.favorite_social_network,
            languages                 : $profilData.data.profilAbout.languages

        },
        validationSchema: yup.object().shape({
            interestedGender: yup
                .string()
                .required()
                .oneOf(["F", "M"])
        }),
        onSubmit: async values => {
            return $mutation.mutate(values)
        },
    });

    let interestedGenderOptions = [
        {
            value: "F",
            title: $_("components.ProfilAbout.InterestedBy.F")
        },
        {
            value: "M",
            title: $_("components.ProfilAbout.InterestedBy.M")
        }
    ];

    let searchOptions = [
        {
            value: 1,
            title: $_("components.ProfilAbout.Search.1")
        },
        {
            value: 2,
            title: $_("components.ProfilAbout.Search.2")
        },
        {
            value: 3,
            title: $_("components.ProfilAbout.Search.3")
        },
        {
            value: 4,
            title: $_("components.ProfilAbout.Search.4")
        }
    ];

    let childrenOptions = [
        {
            value: 1,
            title: $_("components.ProfilAbout.Children.1")
        },
        {
            value: 2,
            title: $_("components.ProfilAbout.Children.2")
        },
        {
            value: 3,
            title: $_("components.ProfilAbout.Children.3")
        },
        {
            value: 4,
            title: $_("components.ProfilAbout.Children.4")
        }
    ];

    let firstStepOptions = [
        {
            value: 1,
            title: $_("components.ProfilAbout.first_step.1")
        },
        {
            value: 2,
            title: $_("components.ProfilAbout.first_step.2")
        },
        {
            value: 3,
            title: $_("components.ProfilAbout.first_step.3")
        }
    ];

    let liveWithOptions = [
        {
            value: 1,
            title: $_("components.ProfilAbout.live_with.1")
        },
        {
            value: 2,
            title: $_("components.ProfilAbout.live_with.2")
        },
        {
            value: 3,
            title: $_("components.ProfilAbout.live_with.3")
        },
        {
            value: 4,
            title: $_("components.ProfilAbout.live_with.4")
        }
    ];

    let favoriteAnimalOptions = [
        {
            value: 1,
            title: $_("components.ProfilAbout.favorite_animal.1")
        },
        {
            value: 2,
            title: $_("components.ProfilAbout.favorite_animal.2")
        },
        {
            value: 3,
            title: $_("components.ProfilAbout.favorite_animal.3")
        },
        {
            value: 4,
            title: $_("components.ProfilAbout.favorite_animal.4")
        },
        {
            value: 5,
            title: $_("components.ProfilAbout.favorite_animal.5")
        },
        {
            value: 6,
            title: $_("components.ProfilAbout.favorite_animal.6")
        },
        {
            value: 7,
            title: $_("components.ProfilAbout.favorite_animal.7")
        },
        {
            value: 7,
            title: $_("components.ProfilAbout.favorite_animal.7")
        },
        {
            value: 8,
            title: $_("components.ProfilAbout.favorite_animal.8")
        },
        {
            value: 9,
            title: $_("components.ProfilAbout.favorite_animal.9")
        },
        {
            value: 10,
            title: $_("components.ProfilAbout.favorite_animal.10")
        },
        {
            value: 11,
            title: $_("components.ProfilAbout.favorite_animal.11")
        },
        {
            value: 12,
            title: $_("components.ProfilAbout.favorite_animal.12")
        },
        {
            value: 13,
            title: $_("components.ProfilAbout.favorite_animal.13")
        },
        {
            value: 14,
            title: $_("components.ProfilAbout.favorite_animal.14")
        },
        {
            value: 15,
            title: $_("components.ProfilAbout.favorite_animal.15")
        },
        {
            value: 16,
            title: $_("components.ProfilAbout.favorite_animal.16")
        },
        {
            value: 17,
            title: $_("components.ProfilAbout.favorite_animal.17")
        },
        {
            value: 18,
            title: $_("components.ProfilAbout.favorite_animal.18")
        },
        {
            value: 19,
            title: $_("components.ProfilAbout.favorite_animal.19")
        },
        {
            value: 20,
            title: $_("components.ProfilAbout.favorite_animal.20")
        },
    ];

    let favoriteSocialNetworkOptions = [
        {
            value: 1,
            title: $_("components.ProfilAbout.favorite_social_network.1")
        },
        {
            value: 2,
            title: $_("components.ProfilAbout.favorite_social_network.2")
        },
        {
            value: 3,
            title: $_("components.ProfilAbout.favorite_social_network.3")
        },
        {
            value: 4,
            title: $_("components.ProfilAbout.favorite_social_network.4")
        },
        {
            value: 5,
            title: $_("components.ProfilAbout.favorite_social_network.5")
        },
        {
            value: 6,
            title: $_("components.ProfilAbout.favorite_social_network.6")
        }
    ];

    let favoriteMusicStyleOptions = [
        {
            value: 1,
            title: $_("components.ProfilAbout.favorite_music_style.1")
        },
        {
            value: 2,
            title: $_("components.ProfilAbout.favorite_music_style.2")
        },
        {
            value: 3,
            title: $_("components.ProfilAbout.favorite_music_style.3")
        },
        {
            value: 4,
            title: $_("components.ProfilAbout.favorite_music_style.4")
        },
        {
            value: 5,
            title: $_("components.ProfilAbout.favorite_music_style.5")
        },
        {
            value: 6,
            title: $_("components.ProfilAbout.favorite_music_style.6")
        },
        {
            value: 7,
            title: $_("components.ProfilAbout.favorite_music_style.7")
        },
        {
            value: 8,
            title: $_("components.ProfilAbout.favorite_music_style.8")
        },
        {
            value: 9,
            title: $_("components.ProfilAbout.favorite_music_style.9")
        },
        {
            value: 10,
            title: $_("components.ProfilAbout.favorite_music_style.10")
        },
        {
            value: 11,
            title: $_("components.ProfilAbout.favorite_music_style.11")
        },
        {
            value: 12,
            title: $_("components.ProfilAbout.favorite_music_style.12")
        },
        {
            value: 13,
            title: $_("components.ProfilAbout.favorite_music_style.13")
        },
        {
            value: 14,
            title: $_("components.ProfilAbout.favorite_music_style.14")
        },
        {
            value: 15,
            title: $_("components.ProfilAbout.favorite_music_style.15")
        },
        {
            value: 16,
            title: $_("components.ProfilAbout.favorite_music_style.16")
        },
        {
            value: 17,
            title: $_("components.ProfilAbout.favorite_music_style.17")
        },
        {
            value: 18,
            title: $_("components.ProfilAbout.favorite_music_style.18")
        },
        {
            value: 19,
            title: $_("components.ProfilAbout.favorite_music_style.19")
        },
        {
            value: 20,
            title: $_("components.ProfilAbout.favorite_music_style.20")
        }
    ];


    let languages = [
        {
            id: "French",
            name: twemoji.parse($_("components.ProfilAbout.languages.French"))
        },
        {
            id: "English",
            name: twemoji.parse($_("components.ProfilAbout.languages.English"))
        },
        {
            id: "Arabic",
            name: twemoji.parse($_("components.ProfilAbout.languages.Arabic"))
        },
        {
            id: "Spanish",
            name: twemoji.parse($_("components.ProfilAbout.languages.Spanish"))
        },
        {
            id: "Deutsch",
            name: twemoji.parse($_("components.ProfilAbout.languages.Deutsch"))
        },
        {
            id: "Russian",
            name: twemoji.parse($_("components.ProfilAbout.languages.Russian"))
        },
        {
            id: "Portuguese",
            name: twemoji.parse($_("components.ProfilAbout.languages.Portuguese"))
        },
        {
            id: "Chinese",
            name: twemoji.parse($_("components.ProfilAbout.languages.Chinese"))
        },
        {
            id: "Japanese",
            name: twemoji.parse($_("components.ProfilAbout.languages.Japanese"))
        },
        {
            id: "Korean",
            name: twemoji.parse($_("components.ProfilAbout.languages.Korean"))
        },
        {
            id: "Polish",
            name: twemoji.parse($_("components.ProfilAbout.languages.Polish"))
        },
        {
            id: "Italian",
            name: twemoji.parse($_("components.ProfilAbout.languages.Italian"))
        },
        {
            id: "Danish",
            name: twemoji.parse($_("components.ProfilAbout.languages.Danish"))
        },
        {
            id: "Luxembourgish",
            name: twemoji.parse($_("components.ProfilAbout.languages.Luxembourgish"))
        }
    ];
</script>

<span class="text-muted">{$_("components.ProfilAbout.About")} :</span><br />
<form on:submit|preventDefault={handleSubmit} id="ProfilUpdate1" class="needs-validation" novalidate>
    {#key $errors}
        <Select 
            name="interestedGender"
            label={$_("components.ProfilAbout.InterestedBy.InterestedBy")}
            on:change={handleChange}
            on:blur={handleChange}
            bind:value={$form.interestedGender}
            feedback={$errors.interestedGender}
            options={interestedGenderOptions} 
        />
        <Select 
            name="search"
            label={$_("components.ProfilAbout.Search.ISearch")}
            on:change={handleChange}
            on:blur={handleChange}
            bind:value={$form.search}
            feedback={$errors.search}
            options={searchOptions} 
        />
        <Select 
            name="children"
            label={$_("components.ProfilAbout.Children.Childrens")}
            on:change={handleChange}
            on:blur={handleChange}
            bind:value={$form.children}
            feedback={$errors.children}
            options={childrenOptions} 
        />
        {#if $form.children === 1}
            <div transition:slide={{ delay: 250, duration: 300, easing: quintOut }}>
                <Number 
                    name="children_number"
                    label={$_("components.ProfilAbout.Children.ChildrensNumbers")}
                    min="0"
                    max="20"
                    on:change={handleChange}
                    on:blur={handleChange}
                    bind:value={$form.children_number}
                    feedback={$errors.children_number}
                />
            </div>
        {/if}
        <Select 
            name="first_step"
            label={$_("components.ProfilAbout.first_step.firstStep")}
            on:change={handleChange}
            on:blur={handleChange}
            bind:value={$form.first_step}
            feedback={$errors.first_step}
            options={firstStepOptions} 
        />
        <Select 
            name="live_with"
            label={$_("components.ProfilAbout.live_with.liveWith")}
            on:change={handleChange}
            on:blur={handleChange}
            bind:value={$form.live_with}
            feedback={$errors.live_with}
            options={liveWithOptions} 
        />
        <Select 
            name="favorite_animal"
            label={$_("components.ProfilAbout.favorite_animal.favoriteAnimal")}
            on:change={handleChange}
            on:blur={handleChange}
            bind:value={$form.favorite_animal}
            feedback={$errors.favorite_animal}
            options={favoriteAnimalOptions} 
        />

        <Text 
            name="work"
            label={$_("components.ProfilAbout.work")}
            feedback={$errors.work}
            on:change={handleChange}
            on:blur={handleChange}
            bind:value={$form.work}
        />

        <Select
            name="favorite_social_network"
            label={$_("components.ProfilAbout.favorite_social_network.favoriteSocialNetwork")}
            on:change={handleChange}
            on:blur={handleChange}
            bind:value={$form.favorite_social_network}
            feedback={$errors.favorite_social_network}
            options={favoriteSocialNetworkOptions}
        />

        <Select
            name="favorite_music_style"
            label={$_("components.ProfilAbout.favorite_music_style.favoriteMusicStyle")}
            on:change={handleChange}
            on:blur={handleChange}
            bind:value={$form.favorite_music_style}
            feedback={$errors.favorite_music_style}
            options={favoriteMusicStyleOptions}
        />

        <FormGroup class="form-group">
            <Label class="languages">{$_("components.ProfilAbout.ISpeak")}</Label>
            <Svelecte options={languages} bind:value={$form.languages} multiple name="languages"></Svelecte>
        </FormGroup>
    {/key}

    <FormGroup class="text-end">
        <!--- TODO Make the form work --->
        {#if $isSubmitting}
            <Spinner /> {$_("components.Forms.LoginForm.loading")}...
        {:else}
            <input type="submit" class="btn btn-outline-secondary" disabled={!isValid} value="Modifier" />
        {/if}
    </FormGroup>
</form>